import './kitStyles';
import React from 'react';
import { Icon } from './Icon';

/**
 * WEB-3310 юнит 1 — сообщение кита, эталон `Notice({ kind = 'info', title,
 * children, action, testid })`: значок вида на 22, заголовок и описание, действие
 * справа. Ошибка — `role=alert`, прочие — `role=status`; цвет только у значка.
 */
export type NoticeKind = 'info' | 'ok' | 'warn' | 'error';

export interface NoticeProps {
  kind?: NoticeKind;
  title?: React.ReactNode;
  children?: React.ReactNode;
  action?: React.ReactNode;
  testid?: string;
}

export function Notice({ kind = 'info', title, children, action, testid }: NoticeProps): React.ReactElement {
  return (
    <div
      className={'notice ' + kind}
      role={kind === 'error' ? 'alert' : 'status'}
      data-testid={testid || 'notice-' + kind}
    >
      <Icon name={kind} size={22} />
      <div className="body">
        <div className="title">{title}</div>
        {children && <div className="desc">{children}</div>}
      </div>
      {action}
    </div>
  );
}
